import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { largeScreen, smallScreen } from '../../../../../common/mixins';

const rules = ({ theme, mini }) => ({
  alignItems: 'center',
  position: 'relative',
  display: 'flex',
  height: '100%',
  extend: [
    {
      condition: !mini,
      style: {
        marginRight: theme.margin.xlarge,
      },
    },
    largeScreen({
      marginRight: theme.margin.large,
    }),
    smallScreen({
      marginRight: !mini ? theme.margin.fine : 'auto',
    }),
  ],
});

const VolumeContainer = ({ mini, children, onMouseEnter, onMouseLeave }) => {
  const { css } = useFela({ mini });

  return (
    <div
      className={css(rules)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </div>
  );
};

VolumeContainer.propTypes = {
  mini: PropTypes.bool,
  children: PropTypes.node,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
};

export default React.memo(VolumeContainer);
